import React from 'react';
import { oddsBoost, moneylineBoost } from '../odds';

// Odds as text. During a Boost Weekend a boosted price shows its normal price crossed out first: ~~1.90~~ 3.80.
// fmtOdds = a market (boosted on a 'markets' weekend) · fmtMoneyline = a moneyline (boosted on a 'moneyline' weekend)
const was = (o, b) => (b > 1 ? <><s className="odd-was">{(o / b).toFixed(2)}</s>{o.toFixed(2)}</> : o.toFixed(2));
export const fmtMoneyline = (o) => (o ? was(o, moneylineBoost()) : '—');
export const fmtOdds = (o) => {
  if (!o) return '—';
  return was(o, oddsBoost());
};
